var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { property } from "lit/decorators.js";
import { deepAwaitMixin } from "./DeepAwaitMixin";
export class FoldableComponent extends deepAwaitMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.expanded = false;
    }
    get firstValues() {
        return this.values.slice(0, 2);
    }
    get lastValues() {
        return this.values.slice(2).slice(-2);
    }
    get hiddenValues() {
        return this.values.slice(2, -2);
    }
    renderedValues(renderedValue, renderedBreak) {
        return html `
            ${this.firstValues.map(renderedValue)}
            ${this.values.length < 10 || this.expanded ?
            this.hiddenValues.map((value, i) => renderedValue(value, this.firstValues.length + i)) :
            renderedBreak}
            ${this.lastValues.map((value, i) => renderedValue(value, this.values.length - this.lastValues.length + i))}
        `;
    }
    renderedComponent(label, content) {
        if (this.values.length <= 10) {
            return html `
                <label>${label}</label>
                ${content}
            `;
        }
        return html `
            <a class="clickable" @click=${() => this.expanded = !this.expanded}>
                <label>
                    ${label}
                    (${this.values.length})
                    ${this.expanded ? '▼' : '▶'}
                </label>
                ${content}
            </a>
        `;
    }
}
FoldableComponent.styles = css `
        .clickable:hover {
            cursor: pointer;
            opacity: 0.8;
        }
    `;
__decorate([
    property({ state: true })
], FoldableComponent.prototype, "expanded", void 0);
//# sourceMappingURL=FoldableComponent.js.map